import { render, staticRenderFns } from "./PersonPicker.vue?vue&type=template&id=65a56a20"
import script from "./PersonPicker.vue?vue&type=script&lang=js"
export * from "./PersonPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports